import React from 'react'
import ReactDOM from 'react-dom'
import template from './template.html'
import Distributor from '~/reactapp/App/Distributor'
import { get } from 'lodash'

import {
  getDistributorFromDistributorList,
  populateDistributorFieldsFromSource,
  populateSourceFieldsFromDistributor,
} from '../services/distributor'

export default {
  restrict: 'E',
  template,
  replace: true,
  bindToController: true,
  controllerAs: 'vm',
  controller: ['storyService', '$scope', '$element', '$rootScope', Controller],
  bindings: {
    storyObj: '=',
    isRequired: '=',
    isRequiredNotify: '=',
  },
}

const reactRenderFactory = ($scope, rootElement) => {
  $scope.$on('$destroy', () => {
    ReactDOM.unmountComponentAtNode(rootElement)
  })

  return (props) => {
    ReactDOM.render(<Distributor {...props} />, rootElement)
  }
}

const getProps = (vm, $rootScope, applyDistributor) => {
  return {
    distributorList: $rootScope.distributorList || [],
    distributor: vm.storyObj.distributor || {},
    isRequired: vm.isRequired || false,
    isRequiredNotify: vm.isRequiredNotify || false,
    applyDistributor,
  }
}

function Controller(storyService, $scope, $element, $rootScope) {
  const applyDistributor = (distributor) => {
    storyService.setStoryProp('distributor', distributor)
  }
  this.render = reactRenderFactory($scope, $element.find('#distributor')[0])

  this.$onInit = () => {
    this.render && this.render(getProps(this, $rootScope, applyDistributor))
  }

  $scope.$watch('vm.isRequiredNotify', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      this.render && this.render(getProps(this, $rootScope, applyDistributor))
    }
  })

  $scope.$watch('vm.storyObj.distributor', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      const props = getProps(this, $rootScope, applyDistributor)

      let selectedDistributor = getDistributorFromDistributorList(
        this.storyObj.distributor.reference_id,
        props.distributorList
      )

      if (!selectedDistributor) {
        selectedDistributor = this.storyObj.distributor || {}
      }

      populateSourceFieldsFromDistributor(this.storyObj, selectedDistributor)
      this.render && this.render(props)
    }
  })

  $scope.$watch('vm.storyObj.source', (newValue, oldValue, scope) => {
    if (
      newValue !== oldValue &&
      get(this.storyObj, 'distributor.mode') !== 'reference'
    ) {
      populateDistributorFieldsFromSource(this.storyObj)
      this.render && this.render(getProps(this, $rootScope, applyDistributor))
    }
  })
}
